import { useState, useEffect, useRef, useMemo } from 'react'
import { useAppSelector } from '../../redux/hooks'
import { RootState } from '../../redux/store'
import { TLevel } from '@smartico/public-api/dist/WSAPI/WSAPITypes'
import TabContentProfile from '../../UI-components/TabContentProfile/TabContentProfile'
import TabContentStatistics from '../../UI-components/TabContentStatistics/TabContentStatistics'
import LevelsScale from '../../UI-components/LevelsScale/LevelsScale'
import defaultAvatar from '../../img/06e9b6ebe5b321d6d7e29d38df03eb74.jpeg'
import { useTranslation } from '../../hooks/useTranslation'
import { Smartico } from '../../core/Smartico'
import SectionWrapper from '../../UI-components/Sections/SectionWrapper/SectionWrapper'
import Utils from '../../core/Utils'
import { TMissionOrBadge } from '@smartico/public-api/dist/WSAPI/WSAPITypes'

const ProfilePage = () => {
	const ITEMS_PER_BOX = 24
	const MOBILE_ITEMS_PER_BOX = 12
	const isMobile = Utils.isMobile()
	const user = useAppSelector((state: RootState) => state.user)
	const profile = useAppSelector((state: RootState) => state.userPublic.profile)
	const levels = useAppSelector((state: RootState) => state.level.levels)
	const customSectionIdsToExclude = [1128]
	const { badges } = useAppSelector((state: RootState) => state.badges)
	const badgesToDisplay = useMemo(() => {
		return badges?.filter((badge: TMissionOrBadge) => !customSectionIdsToExclude.includes(badge.custom_section_id))
	}, [badges])
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [currentLevel, setCurrentLevel] = useState<TLevel>()
	const badgesSection = useRef<HTMLDivElement>(null)
	const [tab, setTab] = useState<string>('profile')
	const [width, setWidth] = useState<number>()

	const { getTexts } = useTranslation(true)

	useEffect(() => {
		if (badgesSection.current) {
			const elementWidth = badgesSection.current.getBoundingClientRect().width
			setWidth(elementWidth)
		}
	}, [badgesSection])

	useEffect(() => {
		if (profile && levels) {
			setCurrentLevel(levels.find((level: TLevel) => level.id === profile.ach_level_current_id))
		}
	}, [profile, levels])

	const getTabContent = (tab: string) => {
		switch (tab) {
			case 'profile':
				return <TabContentProfile />
			case 'statistics':
				return <TabContentStatistics />
			default:
				return
		}
	}

	return (
		<div className="main-content profile-page-content">
			<div className="general-info">
				<div className="user">
					<div className="avatar">
						<div className="icon" style={{ backgroundImage: `url('${profile?.avatar_url || defaultAvatar}')` }} onClick={() => Smartico.dp(`dp:gf_change_avatar&hide_main=true`)} />
					</div>
					<div className="user-info">
						<div className="name" onClick={() => Smartico.dp(`dp:gf_change_nickname&hide_main=true`)}>
							{profile?.public_username && !user.user?.user_ext_id?.endsWith(profile.public_username)
								? profile.public_username
								: user.user?.profile?.firstName || profile?.public_username}
							<div className="edit-icon" />
						</div>
						<div className="email">{user.user?.email}</div>
					</div>
				</div>
				<LevelsScale />
			</div>
			<div className="badges" ref={badgesSection}>
				<SectionWrapper title="Badges" isMiniGamesSection removeShadow width={width}>
					{Utils.adjustItems(badgesToDisplay as TMissionOrBadge[], isMobile ? MOBILE_ITEMS_PER_BOX : ITEMS_PER_BOX).map((container) => (
						<div className="shrink">
							{container.map((badge: TMissionOrBadge) => (
								<img
									src={badge?.image}
									alt={badge?.name}
									width={'100%'}
									height={'100%'}
									style={{ filter: `${!badge?.is_completed ? 'grayscale(80%) contrast(0%) brightness(100%)' : ''}` }}
									onClick={() => Smartico.dp(`dp:gf_badges&id=${badge.id}&hide_main=true`)}
								/>
							))}
						</div>
					))}
				</SectionWrapper>
			</div>
			<div className="tabs">
				<div className="tabs-nav">
					<div className={`tab ${tab === 'profile' ? 'active' : ''}`} onClick={() => setTab('profile')}>
						{getTexts('profile')}
					</div>
					<div className={`tab ${tab === 'statistics' ? 'active' : ''}`} onClick={() => setTab('statistics')}>
						{getTexts('statistics')}
					</div>
				</div>
				<div className="tab-content">{getTabContent(tab)}</div>
			</div>
		</div>
	)
}

export default ProfilePage
